import { Colors } from "../../../utils/colors";

export const ComparisonOverlayLines = ({top, bottom}: {top: number, bottom: number}) => {
    return (
      <>
        <div
          style={{
            position: "absolute",
            width: 1,
            backgroundColor: Colors.success,
            opacity: 0.3,
            top: top,
            bottom: bottom,
            left: 8,
          }}
        />
        <div
          style={{
            width: 1,
            backgroundColor: Colors.success,
            opacity: 0.3,
            position: "absolute",
            top: top,
            bottom: bottom,
            right: 8,
          }}
        />
        <div
          style={{
            width: 1,
            backgroundColor: Colors.success,
            opacity: 0.3,
            position: "absolute",
            top: top,
            bottom: bottom,
            left: "50%", // Position it horizontally in the center
            zIndex: 1000,
          }}
        />
        <div
          style={{
            marginTop: 20,
            height: 6,
            width: "100%",
            backgroundColor: Colors.success,
            opacity: 0.3,
          }}
        />
      </>
    );
  };
  